import React from 'react';

const NotFound = () => {
	return (
		<div className="container">
			<div className="text-center">
				<h1 style={ { fontSize: '7em' } }>404</h1>
				<h3>Page Not found!</h3>
			</div>
		</div>
	);
};

export default NotFound;
